import { ITranslationEntry } from '../lang';

export const LV: ITranslationEntry = {
  translations: {
    notifications: 'Paziņojumi',
    markAllAsRead: 'Atzīmēt visus kā lasītus',
    poweredBy: 'Izstrādāts',
    settings: 'Iestatījumi',
  },
  lang: 'lv',
};
